var _templateObject = _taggedTemplateLiteralLoose(['\n\twidth: 100%;\n\tmax-width: ', ';\n\n\t', '\n\n\t@media (max-width: 960px) {\n\t\tmax-width: ', ';\n\t\tmargin-bottom: ', ';\n\n\t\t&:last-child {\n\t\t\tmargin-bottom: unset;\n\t\t}\n\t}\n\n\t@media (max-width: 680px) {\n\t\tmax-width: ', ';\n\t}\n\n\t', '\n'], ['\n\twidth: 100%;\n\tmax-width: ', ';\n\n\t', '\n\n\t@media (max-width: 960px) {\n\t\tmax-width: ', ';\n\t\tmargin-bottom: ', ';\n\n\t\t&:last-child {\n\t\t\tmargin-bottom: unset;\n\t\t}\n\t}\n\n\t@media (max-width: 680px) {\n\t\tmax-width: ', ';\n\t}\n\n\t', '\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import styled from 'styled-components';
import PropTypes from 'prop-types';
var Item = styled.div(_templateObject, function (_ref) {
  var col = _ref.col,
      _ref$gap = _ref.gap,
      gap = _ref$gap === undefined ? 1 : _ref$gap;
  return col && col < 12 ? 100 * col / 12 - gap + '%' : "100%";
}, function (_ref2) {
  var marginBottom = _ref2.marginBottom;
  return marginBottom && '\n\t\tmargin-bottom: ' + marginBottom + 'px;\n\t';
}, function (_ref3) {
  var colTablet = _ref3.colTablet,
      _ref3$gabTablet = _ref3.gabTablet,
      gabTablet = _ref3$gabTablet === undefined ? 1 : _ref3$gabTablet;
  return colTablet && colTablet < 12 ? 100 * colTablet / 12 - gabTablet + '%' : "100%";
}, function (_ref4) {
  var _ref4$marginBottom = _ref4.marginBottom,
      marginBottom = _ref4$marginBottom === undefined ? 10 : _ref4$marginBottom;
  return marginBottom + 'px';
}, function (_ref5) {
  var colMobile = _ref5.colMobile,
      _ref5$gapMobile = _ref5.gapMobile,
      gapMobile = _ref5$gapMobile === undefined ? 1 : _ref5$gapMobile;
  return colMobile && colMobile < 12 ? 100 * colMobile / 12 - gapMobile + '%' : "100%";
}, function (_ref6) {
  var stretch = _ref6.stretch;
  return stretch && '\n    display: flex;\n    align-self: stretch;\n  ';
});
Item.propTypes = {
  col: PropTypes.number,
  colTablet: PropTypes.number,
  colMobile: PropTypes.number,
  marginBottom: PropTypes.number,
  stretch: PropTypes.bool
};
export default Item;